import { useTopListFilterStore } from '@/store/top-list/top-list-request-date-parameters.store';
import { defineComponent } from 'vue';
import { DateTimeFormatTypes } from '@/models/common/date-time-format-types.model';
import { TOP_LIST_DATE_TIME_SHORTCUTS } from '@/constants/top-list/top-list-date-time-shortcuts.constant';
import { Calendar } from '@element-plus/icons-vue';
import { storeToRefs } from 'pinia';
import { useTopListStore } from '@/store/top-list/top-list.store';
import { getDateTimeRangeFormatted } from '@/utils/get-date-time-range.util';
import { DateTimeRangeTypes } from '@/models/common/date-time-range-types.model';
import { useEnvStore } from '@/store/env.store';
import { TOP_LIST_TABLE_NAME_LIST } from '@/constants/top-list/top-list-table-name-list.model';

const icons = {
  Calendar,
};

export default defineComponent({
  name: 'TopListFilter',
  setup() {
    const { WL_SLUG } = storeToRefs(useEnvStore());

    const topListFilterStore = useTopListFilterStore();
    const { setTopListRequestDateTimeParameter } = topListFilterStore;
    const { requestDateTimeRange, getTopListRequestDateTimeParameter } = storeToRefs(topListFilterStore);

    const topListStore = useTopListStore();
    const { activeTableName } = storeToRefs(topListStore);
    const { clearTopList, resetPaginationTokens, getActiveTableList } = topListStore;

    const updateActiveTableList = (): void => {
      resetPaginationTokens();
      clearTopList();
      getActiveTableList(WL_SLUG.value, getTopListRequestDateTimeParameter.value);
    };

    const changeDateRange = (dateRange: string[]): void => {
      if (!dateRange) {
        setTopListRequestDateTimeParameter(
          getDateTimeRangeFormatted(DateTimeRangeTypes.THIS_MONTH, DateTimeFormatTypes.DATE_TIME_FULL),
        );
      }
      updateActiveTableList();
    };

    return {
      requestDateTimeRange,
      DateTimeFormatTypes,
      TOP_LIST_DATE_TIME_SHORTCUTS,
      icons,
      activeTableName,
      changeDateRange,
      updateActiveTableList,
      TOP_LIST_TABLE_NAME_LIST,
    };
  },
});
